import { Button } from '@chakra-ui/react';
import { IoSparkles } from 'react-icons/io5';

type SpudacusSuggestButtonProps = {
  isComposingMessage: boolean;
  isLoading: boolean;
  onClick: () => void;
};

const SpudacusSuggestButton = ({
  isComposingMessage,
  isLoading,
  onClick,
}: SpudacusSuggestButtonProps) => (
  <Button
    variant="aiAction"
    size="smWithIconLeft"
    onClick={onClick}
    isLoading={isLoading}
    leftIcon={<IoSparkles />}
  >
    {isComposingMessage ? 'AI Review' : 'AI Generate'}
  </Button>
);

export default SpudacusSuggestButton;
